import { render, staticRenderFns } from "./white.vue?vue&type=template&id=3b294e12&"
import script from "./white.vue?vue&type=script&lang=js&"
export * from "./white.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports